import React from 'react'
import './header.scss';
import Brand from '../brand/Brand';
import { config, livechat } from '../../config/config';

type HeaderProps = {
    name: string;    
    toggleWidget: () => void;
    closeButton: () => void;
    backToWidget: () => void;
    isAgentName: boolean;
}

const Header = ({name, toggleWidget, closeButton, backToWidget, isAgentName}: HeaderProps) => {
    return (
        <div className="header">

            { name === config.HEADER_TEXT || name === livechat.HEADER_TEXT || isAgentName ?              
                <div className="header__logo">
                    <Brand isLiveChat={ name === livechat.HEADER_TEXT || isAgentName } />
                </div>  :
                <div className="header__back" tabIndex={1} id="back_button">
                    <img src="/images/back-arrow.svg" 
                        className="header__back-icon"
                        onClick={backToWidget} 
                        alt="back" />
                </div>        
            }

            <div className={ ( config.ISWEBVIEW === false ) ? 'header__name web' : 'header__name' }>
                {name}
            </div>

            {
            !config.ISWEBVIEW && 
            <div className="header__button-vector" tabIndex={2} id="minimize_button">      
                <img src="/images/Vector.svg" 
                className="header__min-icon"
                id="header-minimize-icon"
                onClick={toggleWidget}
                alt="minimize" />
            </div>
            }

            <div className='header__button-close-icon' tabIndex={3} id="close_button" onClick={closeButton}>
                <img src="/images/close.svg" 
                    className="header__close-icon"
                    id="header-close-icon"
                    alt="close" />
            </div>
        </div>
    )
}

export default Header
 

 
